import { Flex, Space } from 'antd'
import { createStyles } from 'antd-style'

import { getFirstScrolledParent } from '@eastcoal/common/utils/dom'

import { WpsFontColorIcon } from '@eastcoal/icon/WpsFontColorIcon'

import { useFontColor } from '../../hooks/useFontColor'
import { SHORTCUTS } from '../../plugins/ShortcutsPlugin/shortcuts'
import { ColorCursor } from '../../ui/ColorCursor'
import { DropdownButton } from '../../ui/DropdownButton'
import { FontColorPicker } from '../../ui/FontColorPicker'
import { MenuButton } from '../../ui/MenuButton'

const useStyles = createStyles(({ token }) => ({
  container: {
    borderRadius: token.borderRadiusSM,
    [`&:hover`]: {
      backgroundColor: token.colorBgTextHover
    }
  }
}))

export const FontColorButton = () => {
  const { defaultFontColor, fontColor, setFontColor, toggleFontColor } =
    useFontColor()

  const { styles } = useStyles()

  return (
    <Space.Compact className={styles.container}>
      <MenuButton
        tooltip={
          <Flex vertical align='center'>
            <span>字体颜色</span>
            <span>{SHORTCUTS.FONT_COLOR}</span>
          </Flex>
        }
        onClick={toggleFontColor}
      >
        <WpsFontColorIcon />
        <ColorCursor color={fontColor} />
      </MenuButton>
      <FontColorPicker
        arrow={false}
        defaultValue={defaultFontColor}
        getPopupContainer={triggerNode => getFirstScrolledParent(triggerNode)}
        placement='bottomRight'
        value={fontColor}
        onChange={setFontColor}
      >
        <DropdownButton compact />
      </FontColorPicker>
    </Space.Compact>
  )
}
